import React from 'react';
import { StyleProp, TextStyle, ViewStyle } from 'react-native';
import { ScheduledAutomationField } from '@shared/data/entity/fields/ScheduledAutomationField';
import { DurationsTextView } from '@shared/scenes/entity/components/fields/ScheduledAutomationEditField';
import { grid } from '@shared/styles';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';

interface Props {
  field: ScheduledAutomationField;
  style: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
}

const textStyles: StyleProp<ViewStyle> = {
  paddingVertical: grid(1),
};

export function ScheduledAutomationCollectionViewField({ field, style, textStyle }: Props) {
  return (
    <CardCollectionViewFieldContainer style={[textStyles, style]}>
      <DurationsTextView durations={field.durations} textStyle={textStyle} />
    </CardCollectionViewFieldContainer>
  );
}
